import React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { ICurrency } from 'src/apis/common';

type FormPropType = FormComponentProps['form'];

export interface IRefundFormContext {
  currency: ICurrency;
  form: FormPropType;
}

const DEFAULT_VALUE: IRefundFormContext = {
  currency: {
    id: 0,
    name: 'Unknown',
    code: 'UNK',
    symbol: '???',
    unitsPerSymbol: 100,
  },
  // @ts-ignore
  form: 'completely bogus, should never be used',
}

export default React.createContext(DEFAULT_VALUE);
